import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { postRequest, putRequest } from '../../../helpers/apiHandler';
import config from '../../../config/Constant';
import CloseIcon from '../../../layouts/SVG/CloseIcon';
import CustomAlert from '../../CustomAlert';
import { GreenApiIconSVG } from '../../../layouts/SVG/GreenIconSVG';
const webhookurl = config.webhookurl;

const AddAPIKeysModal = (props) => {
  const [saveLoading, setSaveLoading] = useState(false);
  const [keyName, setKeyName] = useState('');
  const [keyDescription, setKeyDescription] = useState('');
  const [keyWebhookUrl, setKeyWebhookUrl] = useState('');

  /* ERROR HANDLING */
  /* Key Name */
  const [keyNameError, setKeyNameError] = useState(false);
  const [keyNameErrorName, setKeyNameErrorName] = useState('');

  /* Webhook URL */
  const [keyWebhookUrlError, setKeyWebhookUrlError] = useState(false);
  const [keyWebhookUrlErrorName, setKeyWebhookUrlErrorName] = useState('');

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    if (props.fromEdit) {
      setKeyName(props.activeKey.name);
      setKeyDescription(props.activeKey.description ? props.activeKey.description : '');
      setKeyWebhookUrl(
        props.activeKey.sms_webhook_url ? props.activeKey.sms_webhook_url : ''
      );
      setKeyNameError(false);
      setKeyNameErrorName('');
      setKeyWebhookUrlError(false);
      setKeyWebhookUrlErrorName('');
    } else if (props.fromAdd) {
      setKeyName('');
      setKeyDescription('');
      setKeyWebhookUrl('');
      setKeyNameError(false);
      setKeyNameErrorName('');
      setKeyWebhookUrlError(false);
      setKeyWebhookUrlErrorName('');
    }
  }, [props]);

  const handleUserInput = (e) => {
    const name = e.target.id;
    const { value } = e.target;

    if (name === 'keyName') {
      setKeyName(value);

      if (keyNameError === true) {
        setKeyNameError(false);
        setKeyNameErrorName('');
      }
    } else if (name === 'keyWebhookUrl') {
      setKeyWebhookUrl(value);

      if (keyWebhookUrlError === true) {
        setKeyWebhookUrlError(false);
        setKeyWebhookUrlErrorName('');
      }
    }
  };

  const handleAdd = () => {
    setSaveLoading(true);
    let WHUrl = keyWebhookUrl;

    if (keyWebhookUrl.trim() === '') {
      WHUrl = null;
    }

    const data = {
      name: keyName,
      description: keyDescription,
      sms_webhook_url: WHUrl,
    };

    postRequest('/api-key', data, props.access_token.token, (res) => {
      if (!res.error) {
        setAlertState({
          message: 'Your changes have successfully been saved!',
          show: true,
          variant: 'success',
        });
        props.onClose();
        props.getAPIKeysData();
      } else {
        if (res.code === 1089) {
          setKeyNameError(true);
          setKeyNameErrorName(res.message);
        } else if (res.code === 1090) {
          setKeyNameError(true);
          setKeyNameErrorName('Name is required');
        } else if (res.code === 1118) {
          setKeyWebhookUrlError(true);
          setKeyWebhookUrlErrorName(res.message);
        } else {
          setAlertState({
            message: 'There was an issue adding the API Key',
            show: true,
            variant: 'danger',
          });
        }
      }
      setSaveLoading(false);
    });
  };

  const handleUpdate = () => {
    setSaveLoading(true);
    let WHUrl = keyWebhookUrl;

    if (keyWebhookUrl.trim() === '') {
      WHUrl = null;
    }

    const data = {
      name: keyName,
      description: keyDescription,
      sms_webhook_url: WHUrl,
    };

    putRequest(`/api-key/${props.activeKey.id}`, data, props.access_token.token, (res) => {
      if (!res.error) {
        setAlertState({
          message: 'API Key updated successfully',
          show: true,
          variant: 'success',
        });
        props.onClose();
        props.getAPIKeysData();
      } else {
        if (res.code === 1089) {
          setKeyNameError(true);
          setKeyNameErrorName(res.message);
        } else if (res.code === 1090) {
          setKeyNameError(true);
          setKeyNameErrorName('Name is required');
        } else if (res.code === 1118) {
          setKeyWebhookUrlError(true);
          setKeyWebhookUrlErrorName(res.message);
        } else {
          setAlertState({
            message: 'There was an issue updating the API Key',
            show: true,
            variant: 'danger',
          });
        }
      }
      setSaveLoading(false);
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" type="webhookurl" {...props}>
      Enter URL for SMS status updates. See{' '}
      <a href={webhookurl} target="_blank" rel="noreferrer noopener">
        API Docs
      </a>
      {' '} for details
    </Tooltip>
  );

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <Modal show={props.show} onHide={props.onClose} className="AddAPIKeysModal" centered>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal.Body>
        <CloseIcon handleModalClose={props.onClose} />
        <GreenApiIconSVG />
        <Modal.Title as="h4" style={{ margin: '8px 0 16px' }}>
          {props.fromEdit ? 'Update' : 'Create'} API Key
        </Modal.Title>
        <Form>
          <Form.Group>
            <Form.Label>API Name</Form.Label>
            <input
              className={
                'form-control search-bar container leadlist-input ' +
                (keyNameError ? 'is-invalid' : '')
              }
              id="keyName"
              value={keyName}
              placeholder="API Name"
              type="text"
              onChange={(e) => handleUserInput(e)}
            />
            {keyNameError && <small className="form-text text-danger">{keyNameErrorName}</small>}
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <textarea
              className="form-control search-bar container leadlist-input api-textarea"
              id="keyDescription"
              value={keyDescription}
              placeholder="Description"
              onChange={(e) => setKeyDescription(e.target.value)}
              rows={5}
              style={{ resize: 'none' }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <Form.Label>Notification Webhook URL</Form.Label>
              <OverlayTrigger placement="right" delay={{ hide: 3000 }} overlay={renderTooltip}>
                <i className="fas fa-info-circle ml-1" />
              </OverlayTrigger>
            </Form.Label>
            <input
              className={
                'form-control search-bar container leadlist-input ' +
                (keyWebhookUrlError ? 'is-invalid' : '')
              }
              id="keyWebhookUrl"
              value={keyWebhookUrl}
              placeholder="Notification Webhook URL"
              type="text"
              onChange={(e) => handleUserInput(e)}
            />
            {keyWebhookUrlError && (
              <small className="form-text text-danger">{keyWebhookUrlErrorName}</small>
            )}
          </Form.Group>
          <Form.Group className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
            <Button variant="ghost" onClick={props.onClose} style={{ minWidth: 160 }}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="ml-2"
              onClick={props.fromEdit ? handleUpdate : handleAdd}
              disabled={saveLoading}
              style={{ minWidth: 160 }}
            >
              {saveLoading && <Spinner animation="border" size="sm" className="mr-2" />}
              {props.fromEdit ? 'Update' : 'Create'} API Key
            </Button>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { access_token } = state.auth;

  return {
    access_token,
  };
};

export default connect(mapStateToProps)(AddAPIKeysModal);
